import { StorageProvider } from '../interface/storage-provider.interface';

export class SessionStorageService implements StorageProvider {
  set(key: string, value: any): void {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }

  get(key: string): any {
    const value: string = window.sessionStorage.getItem(key);
    let storedItem: any;

    try {
      storedItem = JSON.parse(value);
    } catch (error) {
      this.remove(key);
      storedItem = null;
    }

    return storedItem;
  }

  remove(key: string): void {
    window.sessionStorage.removeItem(key);
  }
}
